let functions =
{
	scrollTo: function(element)
	{
		element.scrollIntoView({behavior: "smooth", block: "start"});
	},
	getAsset: function(path)
	{
		return "/assets/" + path;
	},
	validateEmail: function(email)
	{
		// eslint-disable-next-line
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email.toLowerCase());
	},
	random: function(min, max)
	{
		return Math.floor(Math.random() * (max - min)) + min;
	},
	chance: function(percent)
	{
		return Math.random() * 100 <= percent;
	},
	/*
		Constrain the value of an object's property between two values

		let vect = {x: 5, y: 10};
		constrain(vect, "x", 10, 20)

		vect.x will be 10

	*/
	constrain: function(obj, prop, min, max)
	{
		obj[prop] = Math.max(obj[prop], min);
		obj[prop] = Math.min(obj[prop], max);
	},
	propBetweenPoints: function(a, b, prop)
	{
		let dX = b.x - a.x;
		let dY = b.y - a.y;

		let res =
		{
			x: a.x + (dX * prop),
			y: a.y + (dY * prop),
		};

		return res;
	},
	defaultValue: function(n, def)
	{
		if(typeof(n) === "undefined")
		{
			return def;
		}
		else return n;
	},
	joinClasses: function(classes)
	{
		let final = "", finalEmpty = true;

		for(let i = 0; i < classes.length; i++)
		{
			if(typeof(classes[i]) !== "undefined" && classes[i].length > 0)
			{
				if(!finalEmpty)
				{
					final += " ";
				}

				final += classes[i];
				finalEmpty = false;
			}
		}

		return final;
	},
	removeURLHash: function()
	{
		window.history.pushState("", document.title, window.location.pathname + window.location.search);
	},
	callIfExists: function(fn, context)
	{
		if(typeof(fn) !== "undefined")
		{
			let args = [];

			for(let i = 2; i < arguments.length; i++)
			{
				args.push(arguments[i]);
			}

			fn.apply(context, args);
		}
	},
	isViewportMobile: function()
	{
		return window.innerWidth <= 920;
	}
};

module.exports = functions;


// WEBPACK FOOTER //
// ./src/js/utils.js